(() => {
  const patchSlideshow = () => {
    document.querySelectorAll('slideshow-component').forEach(el => {
      if (el.reducedMotion || !el.slider) return;

      el.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      el.announcementBarArrowButtonWasClicked = false;

      if (!el.sliderControlWrapper) return;

      const fakeBar = document.createElement('div');
      fakeBar.style.cssText = 'display:none;position:absolute;pointer-events:none;';
      el.appendChild(fakeBar);
      el.announcementBarSlider = fakeBar;

      el.addEventListener('mouseover', () => el.pause?.());
      el.addEventListener('mouseleave', () => {
        if (!el.reducedMotion.matches && !el.announcementBarArrowButtonWasClicked) el.play?.();
      });

      if (el.slider.getAttribute('data-autoplay') === 'true' && !el.reducedMotion.matches) {
        el.play?.();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchSlideshow);
  } else {
    patchSlideshow();
  }
})();

/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const totalHours = Math.floor(ms / 3600000);
    const minutes    = Math.floor((ms % 3600000) / 60000);
    const seconds    = Math.floor((ms % 60000) / 1000);
    return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  let intervalId;

  function updateCountdowns() {
    let hasActive = false;
    document.querySelectorAll('[data-expiration]').forEach(el => {
      const expiration = parseInt(el.dataset.expiration, 10) * 1000;
      const remaining  = expiration - Date.now();
      const timer      = el.querySelector('.sale-countdown__timer');
      if (!timer) return;
      const formatted  = formatCountdown(remaining);
      if (!formatted) {
        el.classList.add('hidden');
      } else {
        timer.textContent = formatted;
        hasActive = true;
      }
    });
    if (!hasActive && intervalId) clearInterval(intervalId);
  }

  updateCountdowns();
  intervalId = setInterval(updateCountdowns, 1000);
})();

/* Cart Promo Slider */
function cartPromoSlide(button, direction) {
  const wrapper = button.closest('.cart-promo__slider-wrapper');
  if (!wrapper) return;
  const track   = wrapper.querySelector('.cart-promo__products');
  if (!track) return;
  const card    = track.querySelector('.cart-recommendations-cart-item');
  if (!card) return;
  track.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' });
  setTimeout(() => cartPromoUpdateArrows(wrapper), 350);
}

function cartPromoUpdateArrows(wrapper) {
  const track = wrapper.querySelector('.cart-promo__products');
  const prev  = wrapper.querySelector('.cart-promo__arrow--prev');
  const next  = wrapper.querySelector('.cart-promo__arrow--next');
  if (!track || !prev || !next) return;
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
}

function cartPromoSelectSize(button) {
  const product = button.closest('[data-promo-product]');
  const variants = product.querySelector('.cart-promo__variants');
  const btnSelect = product.querySelector('.cart-promo__btn-select');
  const btnAdd = product.querySelector('.cart-promo__btn-add');
  if (variants) variants.hidden = false;
  if (btnSelect) btnSelect.hidden = true;
  if (btnAdd) btnAdd.hidden = false;
}

function cartPromoPickVariant(button) {
  const product = button.closest('[data-promo-product]');
  const input = product.querySelector('.cart-promo__variant-input');
  if (input) input.value = button.dataset.variantId;
  product.querySelectorAll('.cart-promo__variant-btn').forEach(btn => {
    btn.classList.toggle('selected', btn === button);
  });
}

function cartPromoAdd(button) {
  const product = button.closest('[data-promo-product]');
  const input = product.querySelector('.cart-promo__variant-input');
  if (!input || !input.value) return;
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Añadiendo...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: input.value, quantity: 1 })
  })
    .then(r => {
      if (!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    })
    .then(() => {
      button.textContent = '¡Agregado!';
      setTimeout(() => {
        const refresh = typeof refreshCartDrawer === 'function'
          ? Promise.resolve(refreshCartDrawer())
          : Promise.resolve();
        refresh.then(() => {
          if (typeof window._refreshPromoBar === 'function') window._refreshPromoBar();
        });
        button.disabled = false;
        button.textContent = originalText;
      }, 1000);
    })
    .catch(err => {
      console.error('Error al agregar:', err);
      button.disabled = false;
      button.textContent = originalText;
    });
}

/* Patch refreshCartDrawer to also re-render the .cart-promo section */
(function () {
  const _parser = new DOMParser();

  function refreshCartPromoSection() {
    return fetch('/cart')
      .then(r => r.text())
      .then(html => {
        const doc = _parser.parseFromString(html, 'text/html');
        const newPromo = doc.querySelector('.cart-promo');
        const host = document.querySelector('#CartDrawer-Pinflag') || document.querySelector('cart-drawer');
        if (!host) return;
        const current = host.querySelector('.cart-promo');
        if (newPromo) {
          if (current) {
            current.outerHTML = newPromo.outerHTML;
          } else {
            const recommendations = host.querySelector('cart-recommendations');
            const footer = host.querySelector('.drawer__footer');
            const anchor = recommendations || footer;
            if (anchor) anchor.insertAdjacentHTML('beforebegin', newPromo.outerHTML);
          }
        } else if (current) {
          current.remove();
        }
        if (typeof window._refreshPromoBar === 'function') window._refreshPromoBar();
      })
      .catch(() => {});
  }

  function patch() {
    const _orig = window.refreshCartDrawer;
    if (typeof _orig !== 'function') return;
    window.refreshCartDrawer = function () {
      return Promise.resolve(_orig()).then(refreshCartPromoSection);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
})();

/* Cart Promo Bar – dynamic progress update */
(function () {
  function formatMoney(cents, format) {
    const amount = Math.round(cents / 100);
    const formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format.replace(/\{\{\s*[\w]+\s*\}\}/g, formatted);
  }

  let _lastTotal = -1;
  let _debounceTimer;

  function updatePromoBar() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(doUpdate, 200);
  }

  function doUpdate() {
    const bar = document.querySelector('.cart-promo-bar');
    if (!bar) return;
    const promoMin = parseInt(bar.dataset.promoMin, 10) || 0;
    if (!promoMin) return;
    const moneyFormat = bar.dataset.moneyFormat || '${{amount}}';
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price;
        if (total === _lastTotal) return;
        _lastTotal = total;

        const unlocked = total >= promoMin;
        const pct      = unlocked ? 100 : Math.floor(total * 100 / promoMin);
        const fill     = bar.querySelector('.cart-promo-bar__fill');
        const text     = bar.querySelector('.cart-promo-bar__text');
        if (fill) fill.style.width = pct + '%';
        if (!text) return;
        const badge     = bar.dataset.promoBadge || '';
        const badgeHtml = badge ? `&nbsp;<span class="cart-promo-bar__badge">${badge}</span>` : '';
        if (unlocked) {
          text.classList.add('cart-promo-bar__text--done');
          const heading   = bar.dataset.promoHeading || '';
          const sep       = heading && badge ? ' &mdash; ' : '';
          const badgePart = badge ? `<strong>${badge}</strong>` : '';
          text.innerHTML = `${heading}${sep}${badgePart}&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>`;
        } else {
          text.classList.remove('cart-promo-bar__text--done');
          const remaining          = promoMin - total;
          const remainingFormatted = formatMoney(remaining, moneyFormat);
          const template = bar.dataset.promoText;
          text.innerHTML = template
            ? template.replace('{amount}', `<strong>${remainingFormatted}</strong>`) + badgeHtml
            : `Te faltan <strong>${remainingFormatted}</strong> para obtener${badgeHtml}`;
        }
      })
      .catch(() => {});
  }

  window._refreshPromoBar = function () {
    _lastTotal = -1;
    updatePromoBar();
  };

  function attachObserver() {
    updatePromoBar();
    const target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer') || document.body;
    new MutationObserver(updatePromoBar).observe(target, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', window._refreshPromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();

(() => {
  const FSB_KEY = 'pf_fsb_zone';
  let _fsbDebounce;
  let _lastTotal = null;

  const applyZone = (fsb, zone) => fsb.setAttribute('data-zone', zone);

  const fsbFormatMoney = (cents, format) => {
    const amount = Math.round(cents / 100);
    const formatted = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format.replace(/\{\{\s*[\w]+\s*\}\}/g, formatted);
  };

  const renderFSB = (fsb, total) => {
    const t1 = parseInt(fsb.dataset.threshold1, 10) || 0;
    const t2 = parseInt(fsb.dataset.threshold2, 10) || 0;
    const fillColor = fsb.dataset.fill || '#121212';
    const doneColor = fsb.dataset.fillDone || '#2e7d32';
    const textIncomplete = fsb.dataset.text || '';
    const textDone = fsb.dataset.textDone || '';
    const moneyFmt = fsb.dataset.moneyFormat || '';
    const discountEnabled = fsb.dataset.discountEnabled === 'true';
    const dt = parseInt(fsb.dataset.discountThreshold, 10) || 0;
    const discountTextIncomplete = fsb.dataset.discountText || '';
    const discountTextDone = fsb.dataset.discountTextDone || '';
    const discountTextFinal = fsb.dataset.discountTextFinal || discountTextDone;
    const tier2Enabled = fsb.dataset.tier2Enabled === 'true';
    const tier2Threshold = parseInt(fsb.dataset.tier2Threshold, 10) || 0;
    const tier2TextIncomplete = fsb.dataset.tier2Text || '';
    const tier2TextDone = fsb.dataset.tier2TextDone || '';

    const activeZone = parseInt(fsb.getAttribute('data-zone'), 10) || 1;
    const activeThreshold = activeZone === 1 ? t1 : t2;
    const shippingDone = activeThreshold > 0 && total >= activeThreshold;
    const discountDone = discountEnabled && dt > 0 && total >= dt;
    const tier2Done = tier2Enabled && tier2Threshold > 0 && total >= tier2Threshold;

    let msg, progress, fillClr;

    if (tier2Done) {
      progress = 100;
      fillClr = doneColor;
      msg = tier2TextDone;
    } else if (tier2Enabled && tier2Threshold > 0 && (discountDone || (!discountEnabled && shippingDone))) {
      const remaining = Math.max(0, tier2Threshold - total);
      progress = Math.min(100, Math.floor(total * 100 / tier2Threshold));
      fillClr = fillColor;
      msg = tier2TextIncomplete.replace('[amount]', `<strong>${fsbFormatMoney(remaining, moneyFmt)}</strong>`);
    } else if (discountDone) {
      progress = 100;
      fillClr = doneColor;
      msg = discountTextFinal;
    } else if (discountEnabled && dt > 0 && shippingDone) {
      const remaining = Math.max(0, dt - total);
      progress = Math.min(100, Math.floor(total * 100 / dt));
      fillClr = fillColor;
      msg = discountTextIncomplete.replace('[amount]', `<strong>${fsbFormatMoney(remaining, moneyFmt)}</strong>`);
    } else if (shippingDone) {
      progress = 100;
      fillClr = doneColor;
      msg = textDone;
    } else {
      const remaining = activeThreshold > 0 ? Math.max(0, activeThreshold - total) : 0;
      progress = activeThreshold > 0 ? Math.min(100, Math.floor(total * 100 / activeThreshold)) : 0;
      fillClr = fillColor;
      msg = activeThreshold > 0
        ? textIncomplete.replace('[amount]', `<strong>${fsbFormatMoney(remaining, moneyFmt)}</strong>`)
        : '';
    }

    const msgEl = fsb.querySelector('.fsb__message');
    const fillEl = fsb.querySelector('.fsb__fill');
    const trackEl = fsb.querySelector('.fsb__track');

    if (msgEl) msgEl.innerHTML = msg;
    if (fillEl) {
      fillEl.style.width = `${progress}%`;
      fillEl.style.backgroundColor = fillClr;
    }
    if (trackEl) trackEl.setAttribute('aria-valuenow', progress);

    fsb.classList.remove('fsb--loading');
  };

  const updateFSBProgress = (delay = 200) => {
    clearTimeout(_fsbDebounce);
    _fsbDebounce = setTimeout(() => {
      if (!document.querySelector('.fsb')) return;
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          _lastTotal = cart.items_subtotal_price ?? cart.total_price;
          document.querySelectorAll('.fsb').forEach(el => renderFSB(el, _lastTotal));
        })
        .catch(() => {});
    }, delay);
  };

  const initFSB = fsb => {
    if (fsb._fsbReady) return;
    fsb._fsbReady = true;
    applyZone(fsb, localStorage.getItem(FSB_KEY) || '1');
    const liquidTotal = parseInt(fsb.dataset.cartTotal, 10);
    if (!isNaN(liquidTotal)) _lastTotal = liquidTotal;
    if (_lastTotal !== null) renderFSB(fsb, _lastTotal);
    fsb.querySelectorAll('.fsb__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const z = btn.getAttribute('data-zone');
        localStorage.setItem(FSB_KEY, z);
        document.querySelectorAll('.fsb').forEach(el => {
          applyZone(el, z);
          if (_lastTotal !== null) renderFSB(el, _lastTotal);
        });
        updateFSBProgress();
      });
    });
  };

  window._fsbScan = () => document.querySelectorAll('.fsb').forEach(initFSB);
  window._updateFSBProgress = updateFSBProgress;

  const fsbSetup = () => {
    window._fsbScan();
    updateFSBProgress(0);

    if (typeof subscribe === 'function') {
      subscribe('cart-update', data => {
        const total = data?.cartData?.total_price;
        if (typeof total === 'number') {
          _lastTotal = total;
          document.querySelectorAll('.fsb').forEach(el => renderFSB(el, _lastTotal));
        } else {
          updateFSBProgress(200);
        }
      });
    }

    const _origRefreshCartDrawer = window.refreshCartDrawer;
    if (typeof _origRefreshCartDrawer === 'function') {
      window.refreshCartDrawer = function() {
        const result = _origRefreshCartDrawer.apply(this, arguments);
        result?.then?.(() => updateFSBProgress(100));
        return result;
      };
    }

    const target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer') || document.body;
    new MutationObserver(mutations => {
      const fsbAdded = mutations.some(m =>
        Array.from(m.addedNodes).some(n =>
          n.nodeType === 1 && (n.classList?.contains('fsb') || n.querySelector?.('.fsb'))
        )
      );
      if (fsbAdded) {
        window._fsbScan();
        updateFSBProgress(0);
      }
    }).observe(target, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fsbSetup);
  } else {
    fsbSetup();
  }
})();

(() => {
  const closeRecSelector = item => {
    const addBtn = item.querySelector('.cart-recommendations-button-add');
    const sizeBtn = item.querySelector('.select-size-button');
    const bagMsg = item.querySelector('.cart-recommendations-bag-message');
    if (!bagMsg) return;
    addBtn?.setAttribute('style', 'display: none !important;');
    sizeBtn?.setAttribute('style', 'display: block !important;');
    bagMsg.setAttribute('style', 'display: none !important;');
  };

  const initRecItem = item => {
    if (item._recInited) return;
    item._recInited = true;

    item.querySelector('.select-size-button')?.addEventListener('click', () => {
      document.querySelectorAll('.cart-recommendations-cart-item').forEach(other => {
        if (other !== item) closeRecSelector(other);
      });
    }, true);

    item.querySelector('.cart-recommendations-button-add')?.addEventListener('click', () => {
      const span = item.querySelector('.cart-recommendations-text-button');
      if (!span) { closeRecSelector(item); return; }
      const obs = new MutationObserver(() => {
        if (span.textContent.trim() === 'agregar al carro') {
          obs.disconnect();
          closeRecSelector(item);
        }
      });
      obs.observe(span, { characterData: true, childList: true, subtree: true });
    });
  };

  const scanRecItems = () => document.querySelectorAll('.cart-recommendations-cart-item').forEach(initRecItem);

  new MutationObserver(scanRecItems).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanRecItems);
  } else {
    scanRecItems();
  }
})();

(() => {
  const LAYOUT_CLASSES = ['cart-drawer-pinflag-flex-column', 'cart-drawer-pinflag-width'];

  const syncCartLayout = () => {
    requestAnimationFrame(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      const drawerInner = document.querySelector('.drawer__inner');
      if (!cartDrawer || !drawerInner) return;
      const isEmpty = cartDrawer.classList.contains('is-empty');
      LAYOUT_CLASSES.forEach(cls => drawerInner.classList.toggle(cls, !isEmpty));
    });
  };

  const setupCartLayout = () => {
    syncCartLayout();
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    new MutationObserver(syncCartLayout).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartLayout);
  } else {
    setupCartLayout();
  }
})();

/* Video Popup Modal */
(function () {
  'use strict';

  function getEmbedUrl(url) {
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^&?\s/]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&enablejsapi=1';
    const vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  function initBtn(btn) {
    if (btn.dataset.popupInited) return;
    btn.dataset.popupInited = '1';
    btn.addEventListener('click', function () {
      const modal = document.getElementById(btn.dataset.popupModal);
      if (!modal) return;
      const embedUrl = getEmbedUrl(btn.dataset.popupUrl);
      if (!embedUrl) {
        window.open(btn.dataset.popupUrl, '_blank', 'noopener');
        return;
      }
      const content = modal.querySelector('.modal-video__video');
      if (content) {
        content.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="eager" title="Video"></iframe>';
      }
      modal.show(btn);
    });
  }

  function initModalCleanup(modal) {
    if (modal.dataset.popupObserving) return;
    modal.dataset.popupObserving = '1';
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && !modal.hasAttribute('open')) {
          const content = modal.querySelector('.modal-video__video');
          if (content) content.innerHTML = '';
        }
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function initAll() {
    document.querySelectorAll('.js-video-popup-btn').forEach(initBtn);
    document.querySelectorAll('.modal-video[id^="VideoPopup-"]').forEach(initModalCleanup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

/* Product card bottom alignment */
(() => {
  function groupByRow(wrappers) {
    const rows = new Map();
    wrappers.forEach(w => {
      const key = w.parentElement.offsetTop;
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(w);
    });
    return [...rows.values()];
  }

  function alignCardBottoms() {
    document.querySelectorAll('.product-grid').forEach(grid => {
      const wrappers = [...grid.querySelectorAll('.product-card-wrapper')];

      wrappers.forEach(w => {
        const t = w.querySelector('.card-top-container');
        if (t) t.style.minHeight = '';
      });

      groupByRow(wrappers).forEach(row => {
        if (row.length <= 1) return;
        const maxH = Math.max(...row.map(w => {
          const t = w.querySelector('.card-top-container');
          return t ? t.offsetHeight : 0;
        }));
        row.forEach(w => {
          const t = w.querySelector('.card-top-container');
          if (t) t.style.minHeight = maxH + 'px';
        });
      });
    });
  }

  let _resizeTimer;

  function onResize() {
    document.querySelectorAll('.product-grid .card-top-container').forEach(t => {
      t.style.minHeight = '';
    });
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(alignCardBottoms, 150);
  }

  const run = () => requestAnimationFrame(alignCardBottoms);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', () => {
    alignCardBottoms();
    setTimeout(alignCardBottoms, 400);
  });

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', run);
})();

(() => {
  let currentZona = null;

  function activateZona(zona) {
    document.querySelectorAll('.nav-tabs .tab-title').forEach((t) => {
      t.classList.remove('active', 'show');
    });
    const tab = document.querySelector(`.nav-tabs .tab-title[href="#zona-${zona}"]`);
    if (tab) tab.classList.add('active', 'show');

    document.querySelectorAll('.tab-pane').forEach((pane) => {
      pane.classList.remove('active', 'show');
    });
    const pane = document.getElementById(`zona-${zona}`);
    if (pane) pane.classList.add('active', 'show');

    currentZona = zona;
  }

  function initFindStoreTabs() {
    document.querySelectorAll('.nav-tabs .tab-title').forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        activateZona(tab.getAttribute('href').replace('#zona-', ''));
      });
    });

    if (!currentZona) {
      const activePane = document.querySelector('.tab-pane.active.show');
      currentZona = activePane ? activePane.id.replace('zona-', '') : 'norte';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFindStoreTabs);
  } else {
    initFindStoreTabs();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.tab-pane, .nav-tabs')) {
      activateZona(currentZona || 'norte');
    }
  });
})();
